import React, { useCallback } from 'react';
import { Skeleton, TextArea } from '@patternfly/react-core';
import ComponentPropTypes from './ComponentPropTypes';
import styles from './TextAreaComponent.module.css';

const TextAreaComponent = ({ model, value, onChange, isLoading }) => {

  const _onChange = useCallback(value => {
    onChange(model, value);
  }, [model, onChange]);

  return (<>
    { isLoading && <Skeleton className={styles.skeleton} /> }
    { !isLoading && <TextArea
      id={model.path}
      autoResize={model.autoResize || true}
      resizeOrientation={model.resizeOrientation || 'vertical'}
      validated={model.validated || 'default'}
      isRequired={model.isRequired || false}
      value={value || model?.properties?.initialValue || ''}
      onChange={(_event, textValue) => _onChange(textValue)}
      isDisabled={model.disabled || false}
      onBlur={model?.properties?.onBlur?.()}
    />
    }
  </>
  );
};

TextAreaComponent.propTypes = ComponentPropTypes;

export default React.memo(TextAreaComponent);
